module.exports = __webpack_public_path__ + "img/objetos-25.2b455309.png";